import TitleDivider from "./titleDivider";
import { FaArrowLeftLong } from "react-icons/fa6";
import useTranslation from "@/hooks/useTranslation";

const Header = ({ children, useHeaderTag = false, ...props }) => {
  return useHeaderTag ? (
    <h1 {...props}>{children}</h1>
  ) : (
    <span {...props}>{children}</span>
  );
};

const ContentHeader = ({
  title,
  brand,
  clickBackButton,
  divider,
  fontSize = 28,
  fontWeight = "bold",
  rtl,
  useHeaderTag = false,
}) => {
  const t = useTranslation();

  return (
    <div>
      <Header
        useHeaderTag={useHeaderTag}
        onClick={() => (clickBackButton && clickBackButton()) || null}
        className={`mt-10 mb-10 ${rtl ? "flex-r" : "flex-l"}`}
        style={{
          lineHeight: "40px",
          cursor: "pointer",
          fontSize: fontSize,
          fontWeight: fontWeight,
        }}
      >
        {clickBackButton && (
          <FaArrowLeftLong size={15} className="mr-10 cursorpointer" />
        )}
        {title || t("homepage_main_title")}
      </Header>
      {divider && <TitleDivider brand={brand} rtl={rtl} />}
    </div>
  );
};

export default ContentHeader;
